import * as E from './errors';

export function random(
	length: number,
	keyspace: string = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
) {
	if ((typeof length !== 'number') && (length < 1)) {
		throw E.user(
			`Length<${length}> must be a positive integer!`,
			{length}
		);
	}
	let result = '';
	const charactersLength = keyspace.length;
	for (let i = 0; i < length; i++) {
		result += keyspace.charAt(Math.floor(Math.random() * charactersLength));
	}
	return (result);
};

export function changeCase(
	source: string,
	toCase: 'lower' | 'upper' | 'camel',
	fromIndex: number = 0,
	toIndex?: number
) {
	if (typeof source !== 'string') {
		throw E.library(
			'strChangesCase: @source: Shall be a String!',
			{source}
		);
	}
	if (toIndex === undefined) {
		toIndex = source.length;
	}
	const toChange = source.slice(fromIndex, toIndex);
	const prefix = source.slice(0, fromIndex);
	const suffix = source.slice(toIndex, source.length);
	let changed;
	if (toCase === 'lower') {
		changed = toChange.toLowerCase();
	} else if (toCase === 'upper') {
		changed = toChange.toUpperCase();
	} else if (toCase === 'camel') {
		const parts = toChange.split(/ |-|_|\n|\t/).filter((x) => {
			return (x !== '');
		});
		if (parts.length === 0) {
			changed = '';
		} else {
			changed = [
				(<string>parts[0]).toLowerCase(),
				parts.slice(1).map((x) => {
					const chars = x.toLowerCase().split('');
					chars[0] = (<string>chars[0]).toUpperCase();
					return (chars.join(''));
				})
			].flat().reduce((a, c) => {
				return (a + c);
			}, '');
		}
	} else {
		throw E.library(
			'changeCase: @toCase: Shall be "lower" | "upper"!',
			{toCase}
		);
	}
	return (prefix + changed + suffix);
};

export function countChar(
	where: string,
	what: string
) {
	return (
		where.split('').reduce((occurencesCount, char) => {
			return ((char === what) ? occurencesCount + 1 : occurencesCount);
		}, 0)
	);
};

export function wildcard(
	wildcard: string,
	str: string
) {
	const wildcardCount = countChar(wildcard, '*');
	if (wildcardCount === 0) {
		return (wildcard === str);
	} else if (
		(wildcardCount === 1) &&
		(wildcard[0] === '*')
	) {
		return (str.endsWith(wildcard.slice(1)));
	} else if (
		(wildcardCount === 2) &&
		(wildcard[0] === '*') &&
		(wildcard[wildcard.length - 1] === '*')
	) {
		return (str.includes(wildcard.slice(1, -1)));
	} else if (
		(wildcardCount === 1) &&
		(wildcard[wildcard.length - 1] === '*')
	) {
		return (str.startsWith(wildcard.slice(0, -1)));
	} else if (wildcardCount === 1) {
		const atom = wildcard.split('*');
		return (str.startsWith(<string>atom[0]) && str.endsWith(<string>atom[1]));
	} else {
		throw new Error('');
	}
};
